import React from "react"
import { Link } from "gatsby"
import LogoKWW from "../logo-kww"

const HeaderLogo = props => {
  return (
    <h2 className="header-logo">
      <Link
        to="/"
        title="Ken Walton, front-end developer and graphic designer."
      >
        <LogoKWW />
      </Link>
    </h2>
  )
}

export default HeaderLogo

//import KwwLogoTemp from "../assets/kww-logo-temp.svg"
